import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=50cea9df&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=50cea9df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cea9df",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme1DesktopNavLoginPopup: require('/app/components/Theme1/Desktop/Nav/LoginPopup.vue').default,Theme1DesktopNavProfileDropdown: require('/app/components/Theme1/Desktop/Nav/ProfileDropdown.vue').default,CommonsLanguageSwitcher: require('/app/components/Commons/LanguageSwitcher.vue').default,Theme1DesktopMenuBar: require('/app/components/Theme1/Desktop/MenuBar.vue').default})
